module.exports = __webpack_public_path__ + "static/media/join_us.9f1d7595.mp4";